import axios from "axios";
import * as types from "./mutation_types";

export const getItems = ({ commit }) => {
  commit(types.ETP_TOGGLE_LOADING);
  axios
    .get("/api/etp/")
    .then((response) => {
      commit(types.ETP_TOGGLE_LOADING);
      commit(types.ETP_SET_ITEMS, response.data);
    })
    .catch((e) => {
      commit(types.ETP_TOGGLE_LOADING);
      commit(types.ETP_SET_ERROR, e.message);
    });
};

export const reset = ({ commit }) => {
  commit(types.ETP_RESET);
};
